import React, { useState, useEffect } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import {FilterModal} from "../../layout/Modal/FilterModal";
import {CustomCheckbox} from "./CustomCheckbox";

const CheckboxFilter = ({ index, filters, applyFilters, filterKey, filterName, type, list }) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedItems, setSelectedItems] = useState([...filters])

  useEffect(() => {
      setSelectedItems([...filters])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  const actionSubmit = () => {
    applyFilters(filterKey, [...selectedItems]);
    setShowModal(false)
  }

  const addItem = item => {
    let items = selectedItems;
    items.push(item);
    setSelectedItems([...items]);
  }

  const removeItem = item => {
    let items = selectedItems.filter(elem => elem.identifier !== item);
    setSelectedItems([...items]);
  }

  const renderButton = () => {
    if (type === 'button') {
      return (
        <Button
          color="primary"
          size="sm"
          className="btn-warning"
          type="button"
          id={`filter-icon-` + index}
          onClick={() => setShowModal(true)}
        >
          <FormattedMessage id="button.filter" />
        </Button>)
    }

    return (
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`filter-icon-${index}`}
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faFilter}
          color={filters.length > 0 ? '#524FD0' : '#8898aa'}
        />
      </Link>
    );
  }

  const renderTooltip = () => {
    return (
      <UncontrolledTooltip
        delay={ 0 }
        target={ `filter-icon-${index}` }
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage id="button.filter" />
      </UncontrolledTooltip>
    );
  }

  const renderList = () => {
    let myList = []
    if (typeof list === 'object') {
      for (const [key, value] of Object.entries(list)) {
        myList[key] = value;
      }
    } else if (Array.isArray(list)) {
        myList = list;
    }
    return myList?.map(renderListItem)
  }

  const renderListItem = (item, index) => {
    const checked = !!selectedItems.find(elem => elem.identifier === index);
    return (
      <CustomCheckbox
        key={`${filterKey}_${index}`}
        name={`${filterKey}_${index}`}
        checked={checked}
        checkboxText={item}
        className="mb-3"
        onChange={(value) => {
          if (! checked) {
            addItem({identifier: index, label: filterName, key: filterKey})
          } else {
            removeItem(index)
          }
        }}
      />
    )
  }

  return (
    <>
      {renderButton()}
      {renderTooltip()}
      <FilterModal
        showModal={showModal}
        closeModal={() => {
          setShowModal(false);
        }}
        confirmationYes={actionSubmit}
      >
        {
          renderList()
        }
      </FilterModal>
    </>
  )
}

export { CheckboxFilter }
